import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import AffiliationPage from './pages/AffiliationPage';
import CommitteePage from './pages/CommitteePage';
import ContactPage from './pages/ContactPage';
import Gallery from './pages/Gallery';
import PlacementPage from './pages/PlacementPage';
import ProspectusPage from './pages/ProspectusPage';
import BPharmaPage from './pages/BPharmaPage';
import DPharmaPage from './pages/DPharmaPage';
import VisionMissionPage from './pages/VisionMissionPage';
import UniversityPage from './pages/UniversityPage';
import PrincipalMessagePage from './pages/PrincipalMessagePage';
import ChairmanMessagePage from './pages/ChairmanMessagePage';
import FeeStructure from './pages/FeeStructure';
import Resistration from './pages/Resistration';
import Pharmacy from './pages/Pharmacy';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfUsePage from './pages/TermsOfUsePage';
import SitemapPage from './pages/SitemapPage';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/affiliation" element={<AffiliationPage />} />
        <Route path="/committee" element={<CommitteePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/placement" element={<PlacementPage />} />
        <Route path="/prospectus" element={<ProspectusPage />} />
        <Route path="/bpharma" element={<BPharmaPage />} />
        <Route path="/dpharma" element={<DPharmaPage />} />
        <Route path="/vision" element={<VisionMissionPage />} />
        <Route path="/university" element={<UniversityPage />} />
        <Route path="/principal-message" element={<PrincipalMessagePage />} />
        <Route path="/chairman" element={<ChairmanMessagePage />} />
        <Route path='/fee-structure'element={<FeeStructure/>}/>
        <Route path='/resistration'element={<Resistration/>}/>
        <Route path='/pharmacy'element={<Pharmacy/>}/>
        <Route path='/prospective'element={<ProspectusPage/>}/>
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-use" element={<TermsOfUsePage />} />
        <Route path="/sitemap" element={<SitemapPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;